// extracted by mini-css-extract-plugin
export default {"flexItem":"CategoryCard_flexItem__FQdNs","textDiv":"CategoryCard_textDiv__sjpc+","bottomText":"CategoryCard_bottomText__sXWe0","image":"CategoryCard_image__dqT1V"};